import type { ConnectAccountStatus, ConnectDesktopBridge } from "@afar-research/contracts";

/** A saved label is not authentication. This call renews and checks the account token. */
export async function restoreBrowserAccount(
  bridge: Pick<ConnectDesktopBridge, "getStatus" | "installations"> | undefined,
): Promise<ConnectAccountStatus> {
  if (!bridge) return { state: "unavailable" };
  const status = await bridge.getStatus();
  if (status.state !== "signed-in") return status;
  await bridge.installations();
  return bridge.getStatus();
}
